// extracted by mini-css-extract-plugin
export default {"wrapper":"To-z","response":"Uo-z","error":"Vo-z","disabled":"Wo-z","buttons":"Xo-z","feedbackQuestionSection":"Yo-z","yesNoWrapper":"Zo-z"};